import { useRoles } from 'domains/Auth/authSlice/useRoles';

export function useGetTranslationKeyByUser(): string {
  const { validateRoles } = useRoles();
  const currentUserHasFullRole = validateRoles('full');

  return currentUserHasFullRole ? 'fullRoleUser' : 'basicUser';
}
